module.exports = "/_next/static/images/calendarImage-7373353358b46287fd9dba8bc92ca220.png";